import { getEnv } from 'util/getEnv';
import StatsigWrapee from './statsig-wrapee/statsig-wrapee.component';
import { getOverrideAdapter } from './statsig-wrapper.utils';

const StatsigWrapper = ({ children }) => {
  return (
    <StatsigWrapee
      sdkKey={getEnv('REACT_APP_STATSIG_KEY')}
      options={{
        environment: { tier: getEnv('REACT_APP_ENV_NAME') },
        overrideAdapter: getOverrideAdapter(),
        networkConfig: {
          preventAllNetworkTraffic:
            !!window.Cypress ||
            (typeof process !== 'undefined' &&
              process.env['NODE_ENV'] === 'test'),
        },
      }}
    >
      {children}
    </StatsigWrapee>
  );
};

export default StatsigWrapper;
